import { CHARACTERS } from "@/game/config";
import { useAuth } from "@/auth";
import { useLang } from "@/i18n";

const T = {
  es: {
    next: (n, name) => `Invitá ${n} amigo${n === 1 ? "" : "s"} más para desbloquear a ${name}`,
    progress: (a, b) => `${a}/${b} amigos`,
    all: "¡Desbloqueaste todos los personajes! 🎉",
  },
  en: {
    next: (n, name) => `Invite ${n} more friend${n === 1 ? "" : "s"} to unlock ${name}`,
    progress: (a, b) => `${a}/${b} friends`,
    all: "You unlocked every character! 🎉",
  },
};

// Honest unlock-progress nudge for signed-in players: shows real invite count
// toward the next locked character so sharing feels rewarding.
export function UnlockProgress() {
  const { user } = useAuth();
  const { lang } = useLang();
  const t = T[lang] || T.es;
  if (!user) return null;

  const invites = user.invites || 0;
  const next = CHARACTERS
    .filter((c) => c.lockTier && invites < c.lockTier)
    .sort((a, b) => a.lockTier - b.lockTier)[0];

  if (!next) {
    return <p data-testid="unlock-progress-all" className="font-vt text-base text-[#4CAF50]">{t.all}</p>;
  }

  const pct = Math.min(100, Math.round((invites / next.lockTier) * 100));
  return (
    <div data-testid="unlock-progress" className="w-full max-w-xs">
      <p className="font-vt text-base text-white/85 leading-tight">{t.next(next.lockTier - invites, next.name)}</p>
      <div className="h-2.5 rounded-full bg-white/15 overflow-hidden mt-1.5">
        <div className="h-full rounded-full bg-gradient-to-r from-[#FFB300] to-[#FFEB3B] transition-all" style={{ width: `${pct}%` }} />
      </div>
      <p className="font-vt text-sm text-[#FFEB3B] mt-1">{t.progress(invites, next.lockTier)}</p>
    </div>
  );
}
